module.exports = __webpack_public_path__ + "img/ldhg_logo001.0cef9732.jpg";